import { Stack, Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
// import "./About.css";

// ----------------------------------------------------------------------

const useStyles = makeStyles((theme) => ({
  "@keyframes scrolling-left1": {
    "0%": {
      transform: "translateX(100%)",
    },
    "100%": {
      transform: "translateX(-100%)",
    },
  },

  "@keyframes scrolling-left2": {
    "0%": {
      transform: "translateX(0%)",
    },
    "100%": {
      transform: "translateX(-200%)",
    },
  },

  flow_text: {
    overflow: "hidden",
    backgroundColor: "#fff",
    width: "100%",
  },
  flowtext_content: {
    fontFamily: "Helvetica",
    color: "#000",
    width: "100%",
    whiteSpace: "nowrap",
  },
  flowtext_1: {
    fontSize: "40px",
    display: "inline-block",
    animation: "scrolling-left1 40s linear infinite",
  },
  flowtext_2: {
    fontSize: "40px",
    display: "inline-block",
    animation: "scrolling-left2 40s linear infinite",
    animationDelay: "20s",
  },
}));

export default function FlowText() {
  const classes = useStyles();

  return (
    <Box className={classes.flow_text}>
      <Typography className={classes.flowtext_content}>
        <Box component="span" className={classes.flowtext_1}>
          &nbsp;WELCOME TO OUR NEIGHBORHOOD WELCOME TO OUR NEIGHBORHOOD WELCOME TO OUR NEIGHBORHOOD
        </Box>
        <Box component="span" className={classes.flowtext_2}>
          &nbsp;WELCOME TO OUR NEIGHBORHOOD WELCOME TO OUR NEIGHBORHOOD WELCOME TO OUR NEIGHBORHOOD&nbsp;
        </Box>
      </Typography>
    </Box>
  );
}
